import { useEffect, useState } from "react";

const API_KEY = "d3dlmohr01qg5k5s4vn0d3dlmohr01qg5k5s4vng";

const useStockPrice = (symbol) => {
    const [price, setPrice] = useState(null);

    useEffect(() => {
        if (!symbol) return;

        const fetchPrice = async () => {
            try {
                const res = await fetch(
                    `https://finnhub.io/api/v1/quote?symbol=${symbol}&token=${API_KEY}`
                );
                const data = await res.json();

                if (data && data.c) {
                    setPrice(data.c); // `c` = current price
                }
            } catch (err) {
                console.error("❌ Error fetching stock price:", err);
            }
        };

        fetchPrice();

        // ⏳ Auto refresh every 10s
        const interval = setInterval(fetchPrice, 10000);

        return () => clearInterval(interval);
    }, [symbol]);

    return price;
};

export default useStockPrice;
